/**
 * v4 header — mobile menu + cart drawer (matches bal-com-v4 Header.tsx behavior).
 */
(function () {
  const header = document.querySelector(".header");
  const menuBtn = document.querySelector(".header__menu-btn");
  const cartBtn = document.querySelector(".header__cart-btn");
  const mobileOverlay = document.getElementById("overlay-mobile");
  const cartOverlay = document.getElementById("overlay-cart");

  /* Move drawer overlays to <body> so section/grid parents cannot clip the footer. */
  [mobileOverlay, cartOverlay].forEach(function (overlay) {
    if (overlay && overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
  });

  function openOverlay(overlay) {
    if (!overlay) return;
    overlay.classList.add("expanded");
    document.documentElement.style.overflow = "hidden";
    if (overlay === mobileOverlay && menuBtn) {
      menuBtn.setAttribute("aria-expanded", "true");
    }
  }

  function closeOverlay(overlay) {
    if (!overlay) return;
    overlay.classList.remove("expanded");
    if (!document.querySelector(".overlay.expanded")) {
      document.documentElement.style.overflow = "";
    }
    if (overlay === mobileOverlay && menuBtn) {
      menuBtn.setAttribute("aria-expanded", "false");
    }
  }

  function getHeaderStackHeight() {
    const header = document.querySelector(".header");
    return header?.offsetHeight ?? 72;
  }

  function syncHeaderStackHeight() {
    const header = document.querySelector(".header");
    const announce = document.querySelector(".announce-bar");
    if (!header) return;
    const navH = header.offsetHeight;
    const announceH = announce?.offsetHeight ?? 0;
    document.documentElement.style.setProperty("--home-sticky-header-h", `${navH}px`);
    document.documentElement.style.setProperty("--v4-header-stack-h", `${navH}px`);
    document.documentElement.style.setProperty("--v4-pdp-sticky-top", `${navH + 24}px`);
    document.documentElement.style.setProperty("--home-hero-offset", `${announceH + navH}px`);
  }

  function scrollToSection(id) {
    if (typeof window.FBScrollToHomeSection === "function" && isHomePath(window.location.pathname)) {
      window.FBScrollToHomeSection(id, "smooth");
      return;
    }
    const target = document.getElementById(id);
    if (!target) return;
    const headerHeight = getHeaderStackHeight();
    const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
    window.scrollTo({ top, behavior: "smooth" });
    history.replaceState(null, "", `#${id}`);
  }

  function scrollAfterOverlayClose(overlay, sectionId) {
    if (overlay instanceof HTMLElement) closeOverlay(overlay);
    /* Wait for cart drawer fade-out so layout/scroll position is stable. */
    const delay = overlay instanceof HTMLElement ? 340 : 0;
    window.setTimeout(() => {
      requestAnimationFrame(() => scrollToSection(sectionId));
    }, delay);
  }

  menuBtn?.addEventListener("click", () => openOverlay(mobileOverlay));
  cartBtn?.addEventListener("click", () => {
    window.V4ShopifyCart?.refresh?.();
    openOverlay(cartOverlay);
  });

  document.querySelectorAll(".overlay .close-outside, .overlay .close").forEach((btn) => {
    btn.addEventListener("click", () => {
      const overlay = btn.closest(".overlay");
      if (overlay) closeOverlay(overlay);
    });
  });

  function isHomePath(pathname) {
    return pathname === "/" || pathname === "";
  }

  function resolveHomeSectionId(href) {
    if (!href) return null;
    if (href.startsWith("#")) {
      const hashId = href.slice(1);
      return hashId || null;
    }
    if (href.startsWith("/#")) {
      const rootId = href.slice(2);
      return rootId || null;
    }
    try {
      const url = new URL(href, window.location.origin);
      if (url.origin === window.location.origin && isHomePath(url.pathname) && url.hash.length > 1) {
        return url.hash.slice(1);
      }
    } catch (err) {}
    return null;
  }

  document.addEventListener("click", (e) => {
    const el = e.target.closest("[data-overlay-close]");
    if (!el) return;

    const overlayId = el.getAttribute("data-overlay-close");
    const overlay = overlayId ? document.getElementById(overlayId) : el.closest(".overlay");

    const scrollTarget =
      el.getAttribute("data-scroll-to") ||
      (el.tagName === "A" ? resolveHomeSectionId(el.getAttribute("href")) : null);

    if (scrollTarget && isHomePath(window.location.pathname) && document.getElementById(scrollTarget)) {
      e.preventDefault();
      e.stopPropagation();
      scrollAfterOverlayClose(overlay instanceof HTMLElement ? overlay : null, scrollTarget);
      return;
    }

    if (overlay instanceof HTMLElement) closeOverlay(overlay);
  });

  mobileOverlay?.querySelectorAll(".header-menu-item").forEach((link) => {
    link.addEventListener("click", (e) => {
      const href = link.getAttribute("href") || "";
      const sectionId = resolveHomeSectionId(href);

      if (sectionId && isHomePath(window.location.pathname) && document.getElementById(sectionId)) {
        e.preventDefault();
        closeOverlay(mobileOverlay);
        requestAnimationFrame(() => scrollToSection(sectionId));
        return;
      }

      if (href.startsWith("#")) {
        e.preventDefault();
        closeOverlay(mobileOverlay);
        if (sectionId) {
          requestAnimationFrame(() => scrollToSection(sectionId));
        }
        return;
      }

      // Real pages (/products/contact, /#faq from another page) — close menu, then navigate
      closeOverlay(mobileOverlay);
    });
  });

  document.querySelectorAll('.header__nav a[href^="#"]:not(.header__nav-link--products)').forEach((link) => {
    link.addEventListener("click", (e) => {
      const id = link.getAttribute("href")?.replace(/^#/, "");
      if (!id || !document.getElementById(id)) return;
      e.preventDefault();
      scrollToSection(id);
    });
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    document.querySelectorAll(".overlay.expanded").forEach((overlay) => {
      closeOverlay(overlay);
    });
  });

  syncHeaderStackHeight();
  window.addEventListener("resize", syncHeaderStackHeight);
})();
